import { render, staticRenderFns } from "./market-analysis-performance.vue?vue&type=template&id=40412d06&scoped=true&"
import script from "./market-analysis-performance.vue?vue&type=script&lang=js&"
export * from "./market-analysis-performance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40412d06",
  null
  
)

export default component.exports